/**
 * BCS Custom Scripts
 */

/* ── Newsletter Popup ────────────────────────────────── */
(function () {
  'use strict';

  var STORAGE_KEY = 'bcs_popup_dismissed';
  var TAB_STORAGE_KEY = 'bcs_popup_tab_dismissed';
  var SUBSCRIBED_KEY = 'bcs_popup_subscribed';
  // BCS-203: 15s delay (avoids Google’s intrusive-interstitial penalty window
  // and the >10s acceptance threshold). Scroll trigger fires earlier for
  // engaged readers — see auto-show block at end of IIFE.
  var DELAY_MS = 15000;
  var SCROLL_TRIGGER_RATIO = 0.5;
  // 30 days — long enough that dismissers aren’t pestered, short enough that
  // we re-engage stale visitors who never converted.
  var RESHOW_MS = 30 * 24 * 60 * 60 * 1000;

  var overlay     = document.getElementById('bcsPopupOverlay');
  var popup       = document.getElementById('bcsPopup');
  var formView    = document.getElementById('bcsPopupFormView');
  var successView = document.getElementById('bcsPopupSuccess');
  var form        = document.getElementById('bcsPopupForm');
  var emailInput  = document.getElementById('bcsPopupEmail');
  var phoneInput  = document.getElementById('bcsPopupPhone');
  var submitBtn   = document.getElementById('bcsPopupSubmit');
  var errorEl     = document.getElementById('bcsPopupError');
  var closeBtn    = document.getElementById('bcsPopupClose');
  var closeBtnS   = document.getElementById('bcsPopupCloseSuccess');
  var copyBtn     = document.getElementById('bcsCopyCode');
  var codeEl      = document.getElementById('bcsDiscountCode');
  var shopBtn     = document.getElementById('bcsPopupShop');
  var tab         = document.getElementById('bcsPopupTab');
  var tabBtn      = document.getElementById('bcsPopupTabBtn');
  var tabClose    = document.getElementById('bcsPopupTabClose');

  if (!popup || !overlay) return;

  var KLAVIYO_LIST_ID = 'WJH8Bm';
  var KLAVIYO_COMPANY_ID = 'T22AZL';

  function hasBeenDismissed() {
    try {
      var ts = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if (!ts) return false;
      return (Date.now() - ts) < RESHOW_MS;
    } catch (e) { return false; }
  }

  function markDismissed() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) { /* noop */ }
  }

  function hasTabBeenDismissed() {
    try {
      var ts = parseInt(localStorage.getItem(TAB_STORAGE_KEY), 10);
      if (!ts) return false;
      return (Date.now() - ts) < RESHOW_MS;
    } catch (e) { return false; }
  }

  function markTabDismissed() {
    try { localStorage.setItem(TAB_STORAGE_KEY, String(Date.now())); } catch (e) { /* noop */ }
  }

  function showTab() {
    if (!tab || hasTabBeenDismissed() || hasSubscribed()) return;
    tab.classList.add('is-visible');
  }

  function showPopup() {
    overlay.classList.add('is-visible');
    popup.classList.add('is-visible');
    tab.classList.remove('is-visible');
    document.body.style.overflow = 'hidden';
    if (emailInput) emailInput.focus();
  }

  function hidePopup(permanently) {
    overlay.classList.remove('is-visible');
    popup.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (permanently) {
      markDismissed();
      showTab();
    }
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.classList.add('is-visible');
  }

  function clearError() {
    errorEl.textContent = '';
    errorEl.classList.remove('is-visible');
  }

  function hasSubscribed() {
    try { return localStorage.getItem(SUBSCRIBED_KEY) === '1'; } catch (e) { return false; }
  }

  function markSubscribed() {
    try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (e) { /* noop */ }
  }

  function showSuccess() {
    formView.style.display = 'none';
    successView.classList.add('is-visible');
    markDismissed();
    markSubscribed();
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* Normalise a phone number to E.164 (default UK +44 if no country code). Returns
     null if the input does not look like a phone number we can confidently send. */
  function normalisePhone(raw) {
    if (!raw) return null;
    var trimmed = String(raw).trim();
    if (!trimmed) return null;

    var hasPlus = trimmed.charAt(0) === '+';
    var digits = trimmed.replace(/\D/g, '');
    if (!digits) return null;

    var e164;
    if (hasPlus) {
      e164 = '+' + digits;
    } else if (digits.charAt(0) === '0') {
      e164 = '+44' + digits.slice(1);
    } else if (digits.length >= 10) {
      e164 = '+' + digits;
    } else {
      return null;
    }

    return /^\+[1-9]\d{6,14}$/.test(e164) ? e164 : null;
  }

  /* Subscribe via Klaviyo Client API */
  function subscribeToKlaviyo(email, phone) {
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="bcs-spinner"></span>';
    clearError();

    var profileAttributes = { email: email };
    if (phone) {
      profileAttributes.phone_number = phone;
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Website Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: KLAVIYO_LIST_ID }
            }
          }
        }
      })
    })
    .then(function (res) {
      if (res.ok || res.status === 202) {
        showSuccess();
      } else {
        return res.json().then(function (data) {
          var msg = 'Something went wrong. Please try again.';
          if (data.errors && data.errors.length) {
            msg = data.errors[0].detail || msg;
          }
          throw new Error(msg);
        });
      }
    })
    .catch(function (err) {
      showError(err.message || 'Something went wrong. Please try again.');
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Unlock 10% Off <svg class="bcs-popup__submit-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();
    var email = emailInput.value.trim();
    var rawPhone = phoneInput ? phoneInput.value.trim() : '';

    if (!email) { showError('Please enter your email address.'); return; }
    if (!isValidEmail(email)) { showError('Please enter a valid email address.'); return; }

    var phone = null;
    if (rawPhone) {
      phone = normalisePhone(rawPhone);
      if (!phone) {
        showError('Please enter a valid phone number, or leave it blank.');
        return;
      }
    }

    subscribeToKlaviyo(email, phone);
  });

  function hidePopupAfterSubscribe() {
    overlay.classList.remove('is-visible');
    popup.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', function () { hidePopup(true); });
  closeBtnS.addEventListener('click', function () { hidePopupAfterSubscribe(); });
  overlay.addEventListener('click', function () { hidePopup(true); });
  shopBtn.addEventListener('click', function () { hidePopupAfterSubscribe(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
      hidePopup(true);
    }
  });

  tabBtn.addEventListener('click', function () { showPopup(); });

  tabClose.addEventListener('click', function (e) {
    e.stopPropagation();
    tab.classList.remove('is-visible');
    markDismissed();
    markTabDismissed();
  });

  /* Copy discount code */
  copyBtn.addEventListener('click', function () {
    var code = codeEl.textContent;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(function () {
        copyBtn.textContent = 'Copied!';
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = 'Copy';
          copyBtn.classList.remove('is-copied');
        }, 2000);
      });
    } else {
      var range = document.createRange();
      range.selectNode(codeEl);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      copyBtn.textContent = 'Copied!';
      copyBtn.classList.add('is-copied');
      setTimeout(function () {
        copyBtn.textContent = 'Copy';
        copyBtn.classList.remove('is-copied');
      }, 2000);
    }
  });

  /* ── Auto-show: delay OR 50% scroll, whichever fires first ──────────
     Skipped entirely for visitors who already subscribed or recently
     dismissed (within RESHOW_MS). Closing the popup shows the tab on
     this page only; a new route does not bring it back.
     BCS v10 (22 Oct 2026): product, cart and checkout-bound pages never open
     the full-screen popup, so it can't interrupt someone about to buy. There
     the small "10% Off" tab shows instead and opens the popup when tapped. */
  var bodyClass = document.body ? document.body.className : '';
  var isBuyingPage = /\btemplate-(product|cart)\b/.test(bodyClass);

  if (hasSubscribed()) {
    /* Already got the coupon — popup stays dormant, tab hidden. */
  } else if (hasTabBeenDismissed() || hasBeenDismissed()) {
    /* Closed the popup or the tab — do not restore the tab on a new page. */
  } else if (isBuyingPage) {
    window.setTimeout(showTab, 8000);
  } else {
    var hasFired = false;

    function triggerOnce() {
      if (hasFired) return;
      hasFired = true;
      window.clearTimeout(delayTimer);
      window.removeEventListener('scroll', onScroll);
      showPopup();
    }

    function onScroll() {
      var doc = document.documentElement;
      var scrollable = (doc.scrollHeight - doc.clientHeight);
      if (scrollable <= 0) return;
      var ratio = (window.pageYOffset || doc.scrollTop) / scrollable;
      if (ratio >= SCROLL_TRIGGER_RATIO) triggerOnce();
    }

    var delayTimer = window.setTimeout(triggerOnce, DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
